/* eslint-disable linebreak-style */
export default function ({ store, redirect, route }) {
    if (store.state.maintain === '1' && route.name !== 'bao-tri') {
        return redirect('/bao-tri');
    }
}
